import { invoiceDescriptor } from '../descriptors/invoice.descriptor.js';
import { invoiceItemDescriptor } from '../descriptors/invoice-item.descriptor.js';
import { mergeErrors } from './mergeErrors.js';
import { nonNegative, positive } from './rules.js';
import { runDescriptorValidation } from './runDescriptorValidation.js';
import { validateCollection } from './validateCollection.js';
import { validateWithRules } from './validateWithRules.js';
/**
 * L0 + L1 validation for the Invoice aggregate (header + items).
 * Single authority for useInvoiceFormConfig.onValidate,
 * invoiceService.createInvoice/updateInvoice, and future mobile/direct writers.
 *
 * Signature takes header + items (not a single entity) because Invoice is a
 * coordinator aggregate, not on OrgScopedCrudService — mirror of validateSalesOrder.
 *
 * Item L0 (descriptor) owns emptiness (`quantity`/`unitPrice` required); L1
 * range rules skip null by design. Messages match the former console onValidate.
 *
 * `ctx` is accepted for symmetry with makeInvoiceDraft; unused for now.
 */
export function validateInvoice(header, items, ctx) {
    const filled = items.filter((i) => i.productId);
    return mergeErrors(filled.length === 0
        ? { 'items.0.productId': 'Adicione ao menos um item com produto.' }
        : undefined, filled.length > 0
        ? validateCollection('items', items, (item) => item.productId
            ? mergeErrors(runDescriptorValidation(invoiceItemDescriptor, item, [
                'productId',
                'quantity',
                'unitPrice',
            ]), validateWithRules(item, {
                quantity: [positive('Quantidade deve ser maior que zero.')],
                unitPrice: [nonNegative('O preço não pode ser negativo.')],
            }))
            : undefined, ctx)
        : undefined, runDescriptorValidation(invoiceDescriptor, header, [
        'number',
        'series',
        'accessKey',
        'direction',
        'partyId',
        'status',
        'state',
        'notes',
    ]));
}
//# sourceMappingURL=validateInvoice.js.map